import { RuleService } from '@/api/services/RuleService';
import { RuleInfoDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getMonitorByIdTool: ToolDefinition = {
  name: 'get_monitor_by_id',
  description: 'Get monitor details by ID. Use for monitor details, current status, failing rows. Returns: id, name, ruleStatus, lastRunStatus (most recent run only), lastRunTimestamp (most recent run only), unresolvedIncidents count, canHaveFailingRows. Shows most recent run only. For run history or "last successful run", use get_monitor_runs.',
  input_schema: {
    type: 'object',
    properties: {
      id: {
        type: 'string',
        description: 'Monitor UUID',
      },
    },
    required: ['id'],
  },
};

/**
 * Execute the get_monitor_by_id tool
 */
export async function executeGetMonitorById(
  params: { id: string },
): Promise<RuleInfoDto | { error: string }> {
  try {
    const result = await callWithContext('sifflet-ai-chat', () => RuleService.getSiffletRuleInfo({
      id: params.id,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getMonitorByIdTool;
